import SweetAlert from "@/components/shared/SweetAlert";
import {
  AddStudentToAttendance,
  AttendanceResponseWithPagination,
  AttendanceStudent,
  CenterLecture,
  CentersPaginatedResponse,
  CourseParsed,
  CreateResponse,
  EnrollmentsPaginatedResponse,
  LecturesResponseWithPagination,
  ResponseApi,
  ScheduleDetails,
  ScheduleLecturesPaginatedResponse,
  SchedulesPaginatedResponse,
  Student,
  StudentAttendanceDetails,
  StudentAttendanceDetailsResponseApi,
  TinyLecture,
  TinySchedule,
} from "@/types/center";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import centerThunks from "../centerThunks";
import { showToastNotification } from "@/utils/toast";

interface InitStateType {
  loading: boolean;
  error: string | null;
  ScheduleDetails: ScheduleDetails | null;
  teacherLectureDetailsForSelect: any | null;
  centersPagination: CentersPaginatedResponse["data"] | null;
  schedulesPagination: SchedulesPaginatedResponse["data"] | null;
  studentSchedule: EnrollmentsPaginatedResponse["data"] | null;
  scheduleLectures: ScheduleLecturesPaginatedResponse["data"] | null;
  studentsForSelect: Student[] | null;
  studentAttendanceDetails: StudentAttendanceDetails[] | null;
  teacherCenterLectures: LecturesResponseWithPagination["data"] | null;
  lectureForSelect: TinyLecture[] | null;
  coursesParsed: CourseParsed[] | null;
  centerCoursesParsed: CourseParsed[] | null;
  tinySchedule: TinySchedule[] | null;
  teacherLectureDetails: CenterLecture | null;
  getAttendanceLectureWithPagination:
    | AttendanceResponseWithPagination["data"]
    | null;
  eligibleStudents: Student[] | null;
  attendanceStudent: AddStudentToAttendance[] | null;
}

// const initialState: CentersState = {
//   loading: false,
//   error: null,
//   data: null,
// };
export const initialState: InitStateType = {
  ScheduleDetails: null,
  eligibleStudents: null,
  teacherLectureDetailsForSelect: null,
  attendanceStudent: null,
  getAttendanceLectureWithPagination: null,
  teacherLectureDetails: null,
  centerCoursesParsed: null,
  coursesParsed: null,
  lectureForSelect: null,
  studentSchedule: null,
  scheduleLectures: null,
  centersPagination: null,
  schedulesPagination: null,
  studentsForSelect: null,
  studentAttendanceDetails: null,
  teacherCenterLectures: null,
  tinySchedule: null,
  loading: false,
  error: null,
};

const centersSlice = createSlice({
  name: "Centers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(centerThunks.getTeacherCenterPagination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        centerThunks.getTeacherCenterPagination.fulfilled,
        (state, action: PayloadAction<CentersPaginatedResponse>) => {
          state.loading = false;
          state.centersPagination = action.payload.data;
          console.log(action.payload.data, "from slice");
        }
      )
      .addCase(
        centerThunks.getTeacherCenterPagination.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )

      .addCase(
        centerThunks.createCenter.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          showToastNotification.success(
            action.payload?.message || "تم إنشاء المركز بنجاح"
          );
        }
      )
      .addCase(centerThunks.createCenter.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        showToastNotification.error(state.error || "حدث خطأ ما");
      })

      .addCase(
        centerThunks.updateCenter.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          showToastNotification.success(
            action.payload?.message || "تم تحديث المركز بنجاح"
          );
        }
      )
      .addCase(centerThunks.updateCenter.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(centerThunks.deleteCenter.fulfilled, (state, action) => {
        state.loading = false;
        // SweetAlert({
        //   title: "عملية ناجحة",
        //   text: action.payload?.message,
        //   iconName: "success",
        //   buttonText: "حسنا",
        // });
        showToastNotification.success(
          action.payload?.message || "تم حذف المركز بنجاح"
        );
      })
      .addCase(centerThunks.deleteCenter.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(
        centerThunks.correctExam.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تصحيح الامتحان بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.correctExam.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";

          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.noteHandler.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث الملاحظة بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.noteHandler.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";

          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.warningHandler.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث التحذير بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.warningHandler.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";

          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.getSchedulesWithPagination.fulfilled,
        (state, action: PayloadAction<SchedulesPaginatedResponse>) => {
          state.loading = false;
          state.schedulesPagination = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getSchedulesWithPagination.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.createSchedule.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم إنشاء الجدول بنجاح"
          );
        }
      )
      .addCase(centerThunks.createSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })

      .addCase(
        centerThunks.updateSchedule.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث الجدول بنجاح"
          );
        }
      )
      .addCase(centerThunks.updateSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(centerThunks.deleteSchedule.fulfilled, (state, action) => {
        state.loading = false;
        // SweetAlert({
        //   title: "عملية ناجحة",
        //   text: action.payload?.message,
        //   iconName: "success",
        //   buttonText: "حسنا",
        // });
        showToastNotification.success(
          action.payload?.message || "تم حذف الجدول بنجاح"
        );
      })
      .addCase(centerThunks.deleteSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })

      .addCase(
        centerThunks.getStudentSchedule.fulfilled,
        (state, action: PayloadAction<EnrollmentsPaginatedResponse>) => {
          state.loading = false;
          state.studentSchedule = action.payload.data;
        }
      )
      .addCase(centerThunks.getStudentSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
      })

      .addCase(
        centerThunks.getScheduleLectures.fulfilled,
        (state, action: PayloadAction<ScheduleLecturesPaginatedResponse>) => {
          state.loading = false;
          state.scheduleLectures = action.payload.data;
        }
      )
      .addCase(centerThunks.getScheduleLectures.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
      })

      .addCase(
        centerThunks.getStudentsForSelectOption.fulfilled,
        (state, action: PayloadAction<ResponseApi<Student[]>>) => {
          state.loading = false;
          state.studentsForSelect = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getStudentsForSelectOption.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.addStudentsToSchedule.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم إضافة الطلاب إلى الجدول بنجاح"
          );
        }
      )
      .addCase(centerThunks.addStudentsToSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(
        centerThunks.studentBlocked.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم حظر/إلغاء حظر الطالب بنجاح"
          );
        }
      )
      .addCase(centerThunks.studentBlocked.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(
        centerThunks.getStudentAttendanceDetails.fulfilled,
        (state, action: PayloadAction<StudentAttendanceDetailsResponseApi>) => {
          state.loading = false;
          state.studentAttendanceDetails = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getStudentAttendanceDetails.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.getStudentAllDetails.fulfilled,
        (state, action: PayloadAction<StudentAttendanceDetailsResponseApi>) => {
          state.loading = false;
          state.studentAttendanceDetails = action.payload.data;
        }
      )
      .addCase(centerThunks.getStudentAllDetails.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
      })
      .addCase(
        centerThunks.getStudentForSelectToPreparePage.fulfilled,
        (state, action: PayloadAction<ResponseApi<AttendanceStudent[]>>) => {
          state.loading = false;
          state.attendanceStudent = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getStudentForSelectToPreparePage.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.getTeacherCenterLectures.fulfilled,
        (state, action: PayloadAction<LecturesResponseWithPagination>) => {
          state.loading = false;
          state.teacherCenterLectures = action.payload.data;
        }
      )
      .addCase(
        centerThunks.createLecture.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم إنشاء المحاضرة بنجاح"
          );
        }
      )
      .addCase(centerThunks.createLecture.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(
        centerThunks.getTeacherCenterLecturesForSelect.fulfilled,
        (state, action: PayloadAction<ResponseApi<TinyLecture[]>>) => {
          state.loading = false;
          state.lectureForSelect = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getCoursesParsed.fulfilled,
        (state, action: PayloadAction<ResponseApi<CourseParsed[]>>) => {
          state.loading = false;
          state.coursesParsed = action.payload.data;
        }
      )
      .addCase(centerThunks.getCoursesParsed.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
      })
      .addCase(
        centerThunks.getCenterCoursesParsed.fulfilled,
        (state, action: PayloadAction<ResponseApi<CourseParsed[]>>) => {
          state.loading = false;
          state.centerCoursesParsed = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getCenterCoursesParsed.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.getSchedulesWithoutPagination.fulfilled,
        (state, action: PayloadAction<ResponseApi<TinySchedule[]>>) => {
          state.loading = false;
          state.tinySchedule = action.payload.data;
        }
      )
      .addCase(
        centerThunks.getSchedulesWithoutPagination.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.getTeacherLectureDetails.fulfilled,
        (state, action: PayloadAction<ResponseApi<CenterLecture>>) => {
          state.loading = false;
          state.teacherLectureDetails = action.payload.data;
        }
      )

      .addCase(
        centerThunks.getTeacherLectureDetails.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.getAttendanceLectureWithPagination.fulfilled,
        (state, action: PayloadAction<AttendanceResponseWithPagination>) => {
          state.loading = false;
          state.getAttendanceLectureWithPagination = action.payload.data;
        }
      )

      .addCase(
        centerThunks.getAttendanceLectureWithPagination.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.getTeacherLectureDetailsForSelect.fulfilled,
        (state, action: PayloadAction<AttendanceResponseWithPagination>) => {
          state.loading = false;
          state.teacherLectureDetailsForSelect = action.payload.data;
        }
      )

      .addCase(
        centerThunks.getTeacherLectureDetailsForSelect.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            (action.payload as string) ||
            action.error.message ||
            "Unknown error";
        }
      )
      .addCase(
        centerThunks.eligibleStudents.fulfilled,
        (state, action: PayloadAction<ResponseApi<Student[]>>) => {
          state.loading = false;
          state.eligibleStudents = action.payload.data;
        }
      )

      .addCase(centerThunks.getSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
      })
      .addCase(
        centerThunks.getSchedule.fulfilled,
        (state, action: PayloadAction<ResponseApi<ScheduleDetails>>) => {
          state.loading = false;
          state.ScheduleDetails = action.payload.data;
        }
      )

      .addCase(centerThunks.eligibleStudents.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
      })

      .addCase(
        centerThunks.updateLecture.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث المحاضرة بنجاح"
          );
        }
      )
      .addCase(centerThunks.updateLecture.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || action.error.message || "Unknown error";
        // SweetAlert({
        //   title: "خطأ",
        //   text: state.error,
        //   iconName: "error",
        //   buttonText: "حسنا",
        // });
        showToastNotification.error(state.error || "حدث خطأ ما");
      })
      .addCase(
        centerThunks.recording.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تسجيل الحضور بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.recording.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          console.log(action, "error rejected");

          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";
          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.markIndividualStudentAttendance.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث حالة حضور الطالب بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.markIndividualStudentAttendance.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          console.log(action, "error rejected");

          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";
          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.markAllPresent.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث حالة حضور الجميع بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.markAllPresent.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          console.log(action, "error rejected");

          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";
          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.markAllAbsent.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم تحديث حالة غياب الجميع بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.markAllAbsent.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          console.log(action, "error rejected");

          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";
          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      )
      .addCase(
        centerThunks.addStudentsToAttendance.fulfilled,
        (state, action: PayloadAction<CreateResponse>) => {
          state.loading = false;
          // SweetAlert({
          //   title: "عملية ناجحة",
          //   text: action.payload?.message,
          //   iconName: "success",
          //   buttonText: "حسنا",
          // });
          showToastNotification.success(
            action.payload?.message || "تم إضافة الطلاب إلى الحضور بنجاح"
          );
        }
      )
      .addCase(
        centerThunks.addStudentsToAttendance.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          console.log(action, "error rejected");

          state.error =
            (action.payload.message as any) ||
            action?.payload.error?.message ||
            "Unknown error";
          // SweetAlert({
          //   title: "خطأ",
          //   text: state.error,
          //   iconName: "error",
          //   buttonText: "حسنا",
          // });
          showToastNotification.error(state.error || "حدث خطأ ما");
        }
      );
  },
});

const CentersSystem = { centerThunks, centersSlice };
export default CentersSystem;
